import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useToast} from 'react-native-toast-notifications';
import {copyLink} from 'utils/mediafire';
import {getHost} from 'utils/platform';

export function useCopyLink(ids: string[], url: string) {
  const toast = useToast();
  const {t} = useLingui();
  return useCallback((e: any) => {
    e?.stopPropagation && e.stopPropagation();
    copyLink(ids.length === 1 ? url : `${getHost(true)}/folder/${ids.join(',')}/shared`);
    toast.show(t`Copied share link to clipboard`);
  }, [ids, url]);
}
